import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useScrollReveal } from '../../hooks/useScrollReveal';

export default function Footer() {
  const footerRef = useScrollReveal('.footer-reveal', { y: 24, duration: 0.6, stagger: 0.1, start: 'top 95%' });

  return (
    <footer ref={footerRef} data-testid="footer" className="bg-[#0D1B2A] text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="footer-reveal grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <h3 className="font-heading font-bold text-xl text-white mb-3">A7 Globetech</h3>
            <p className="font-body text-sm text-white/60 leading-relaxed">
              Empowering professionals with industry-leading software technologies training and development.
            </p>
          </div>
          <div>
            <p className="font-body text-xs font-semibold text-[#A8D4FF] uppercase tracking-wider mb-4">Quick Links</p>
            <div className="space-y-2.5">
              {['Services', 'Testimonials', 'Pricing', 'Contact'].map(label => (
                <a
                  key={label}
                  href={`#${label.toLowerCase()}`}
                  className="flex items-center gap-1 font-body text-sm text-white/60 hover:text-white transition-colors"
                >
                  {label} <ArrowUpRight className="w-3 h-3" />
                </a>
              ))}
            </div>
          </div>
          <div>
            <p className="font-body text-xs font-semibold text-[#A8D4FF] uppercase tracking-wider mb-4">Programs</p>
            <div className="space-y-2.5">
              {['Data Science', 'ServiceNow', 'Salesforce', 'Cloud Computing', 'Full Stack Dev'].map(label => (
                <p key={label} className="font-body text-sm text-white/60">{label}</p>
              ))}
            </div>
          </div>
          <div>
            <p className="font-body text-xs font-semibold text-[#A8D4FF] uppercase tracking-wider mb-4">Contact</p>
            <div className="space-y-2.5">
              <p className="font-body text-sm text-white/60">info@a7globetech.com</p>
              <p className="font-body text-sm text-white/60">+91 90328 09977</p>
               <p className="font-body text-sm text-white/60">
                Flat No 501, Navya Gardenia, Phase-III,<br />
                Kamalapuri Colony, Banjara Hills,<br />
                Sagar Society, Srinagar Colony,<br />
                Hyderabad, India 500073
              </p>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="font-body text-xs text-white/40">
            &copy; {new Date().getFullYear()} A7 Globetech LLP. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <p className="font-body text-xs text-white/40">
              Software Technologies Training & Development
            </p>
            <Link to="/privacy" className="font-body text-xs text-white/40 hover:text-white transition-colors">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
